import { render, staticRenderFns } from "./SocialMediaProfiles.vue?vue&type=template&id=2d17dae0"
import script from "./SocialMediaProfiles.vue?vue&type=script&lang=js"
export * from "./SocialMediaProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports